var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.imageUri && _vm.shouldShow)?_c('div',{staticClass:"logo pr-3"},[_c('figure',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.imageUri,"alt":_vm.name},on:{"error":_vm.noImage}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }